import { axios, transformAxiosError } from "../utils/axios.create";
import { EventLog } from "../domain/eventlog.interface";

const findByParticipant = async (
  participantId: string,
  enrollmentId: string,
): Promise<EventLog[]> => {
  const url = `/participants/${participantId}/event-logs?enrollmentId=${enrollmentId}`;
  return axios
    .get<{ body: EventLog[] }>(url)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const EventLogsService = {
  findByParticipant,
};
